/**
 * Created by decipaliz on 28.06.2023
 *
 * ErrorWindow is a prefab window (Prefab.createWindow): layout in errorwindow.prefab.json,
 * behavior in ErrorWindowPropertySource / ErrorWindowController. Opened with { debugInfo }
 * by the error notification and the git manager.
 */

const ErrorWindow = Prefab.createWindow("error_window", "error_window_prefab_json", {
    bundles: ["dev_snapshots"]
});
